/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Card, CardContent, Grid, Skeleton, Typography } from '@mui/material';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import { formatKm } from './constants';

const Field = ({ label, value }) => (
  <Box>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ textTransform: 'uppercase', letterSpacing: 0.4, fontWeight: 600, fontSize: '0.65rem' }}
    >
      {label}
    </Typography>
    <Typography variant="body2" sx={{ fontWeight: 500, mt: 0.25 }}>
      {value ?? '—'}
    </Typography>
  </Box>
);

Field.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const VeiculoSummarySkeleton = () => (
  <Card variant="outlined" sx={{ borderRadius: 2 }}>
    <CardContent sx={{ py: 2, '&:last-child': { pb: 2 } }}>
      <Skeleton width={120} height={32} />
      <Grid container spacing={2} sx={{ mt: 0.5 }}>
        {[1, 2, 3, 4, 5, 6].map((key) => (
          <Grid key={key} size={{ xs: 6, sm: 4, md: 2 }}>
            <Skeleton width="80%" height={14} />
            <Skeleton width="60%" height={20} sx={{ mt: 0.5 }} />
          </Grid>
        ))}
      </Grid>
    </CardContent>
  </Card>
);

const VeiculoSummary = ({ veiculo, loading, visible }) => {
  if (!visible) return null;
  if (loading) return <VeiculoSummarySkeleton />;
  if (!veiculo) return null;

  const modeloLabel = [veiculo.fabricante, veiculo.modelo, veiculo.ano]
    .filter(Boolean)
    .join(' · ');

  return (
    <Card variant="outlined" sx={{ borderRadius: 2 }}>
      <CardContent sx={{ py: 2, '&:last-child': { pb: 2 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <DirectionsCarOutlinedIcon color="primary" fontSize="small" />
          <Typography variant="h5" component="span" sx={{ fontWeight: 700, letterSpacing: 0.5 }}>
            {veiculo.placa || '—'}
          </Typography>
          {modeloLabel && (
            <Typography variant="body2" color="text.secondary" component="span">
              {modeloLabel}
            </Typography>
          )}
        </Box>
        <Grid container spacing={2}>
          <Grid size={{ xs: 6, sm: 4, md: 2 }}>
            <Field label="Categoria" value={veiculo.categoria} />
          </Grid>
          <Grid size={{ xs: 6, sm: 4, md: 2 }}>
            <Field label="Proprietário" value={veiculo.tipoVeiculo} />
          </Grid>
          <Grid size={{ xs: 6, sm: 4, md: 2 }}>
            <Field label="Nº Frota" value={veiculo.numFrota} />
          </Grid>
          <Grid size={{ xs: 6, sm: 4, md: 2 }}>
            <Field label="Cor" value={veiculo.cor} />
          </Grid>
          <Grid size={{ xs: 6, sm: 4, md: 2 }}>
            <Field label="Combustível" value={veiculo.combustivel} />
          </Grid>
          <Grid size={{ xs: 6, sm: 4, md: 2 }}>
            <Field label="KM atual" value={formatKm(veiculo.kmAtual)} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

VeiculoSummary.propTypes = {
  veiculo: PropTypes.shape({
    id: PropTypes.string,
    placa: PropTypes.string,
    modelo: PropTypes.string,
    fabricante: PropTypes.string,
    ano: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    categoria: PropTypes.string,
    tipoVeiculo: PropTypes.string,
    cor: PropTypes.string,
    combustivel: PropTypes.string,
    numFrota: PropTypes.string,
    kmAtual: PropTypes.number,
  }),
  loading: PropTypes.bool,
  visible: PropTypes.bool,
};

VeiculoSummary.defaultProps = {
  veiculo: null,
  loading: false,
  visible: false,
};

export default VeiculoSummary;
